import jwtDecode from "jwt-decode";

class JWT {
    constructor(jwt) {
        this.jwt = jwtDecode(jwt);
        this.raw = jwt;
    }

    get isDemo() {
        return (
            this.jwt["http://adadot.com/organizationId"] === "demo-org" &&
            this.jwt.sub === "demo-user"
        );
    }

    get orgId() {
        return this.jwt["http://adadot.com/organizationId"];
    }

    get permissions() {
        return this.jwt["http://adadot.com/resource_permissions"];
    }

    get sub() {
        return this.jwt.sub;
    }

    get exp() {
        return this.jwt.exp;
    }

    get plans() {
        return this.jwt["http://adadot.com/plans"];
    }

    get mergedIdentity() {
        return this.jwt["http://adadot.com/merged_identity"];
    }

    get loginMethodVerified() {
        return this.jwt["http://adadot.com/login_method_verified"];
    }
}

export default JWT;
